<template>
    <el-dialog title="兑换" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <div class="transfer-box">
            <div class="zchz">
                <div class="zz-l">
                    <div class="zl-y"></div>
                    <div class="zl-x"></div>
                    <img class="z-img" src="@/assets/img-pc/change_13.png" />
                    <div class="zl-x"></div>
                    <div class="zl-y" style="border: 0.125rem solid rgb(246, 70, 93);"></div>
                </div>
                <div class="zz-r">
                    <div class="z-t"><span>从</span></div>
                    <div class="as">
                        <el-select v-model="form.value" placeholder="请选择" style="width: 100%;">
                        </el-select>
                    </div>
                    <div class="z-t"><span>至</span></div>
                    <el-select v-model="form.value" placeholder="请选择" style="width: 100%;">
                    </el-select>
                </div>
            </div>
            <div class="i-t">币种</div>
            <el-select v-model="form.value" placeholder="请选择" style="width: 100%;"></el-select>
            <div class="i-t" style="margin-top: 12px;">兑换数量</div>
            <div class="i-i">
                <el-input v-model="form.type">
                    <template slot="suffix">
                        <div class="dad">全部</div>
                    </template>
                </el-input>
            </div>
            <div class="i-t" style="margin-top: 12px;">余额：0</div>
            <div class="butt"> 兑换 </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: this.visible,
            form: {}
        };
    },
    watch: {
        dialogVisible(val) {
            this.$emit("update:visible", val)
        },
        visible(val) {
            this.dialogVisible = val
        }
    },
    mounted() {

    },
    beforeUnmount() { },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn {
    font-size: 22px;
    color: #fff
}

::v-deep el-dialog__title {
    color: #fff
}

::v-deep .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
}

.transfer-box {
    color: #333;
    width: 520px;
    border: 2px solid #2c2c3e;
    padding: 20px 30px 30px;
    border-radius: 12px;
}

.zchz {
    display: flex;
    align-items: center;
    margin-bottom: 47px;

    .zz-l {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .zl-y {
            width: 10px;
            height: 10px;
            border: 2px solid #0ecb81;
            border-radius: 50%;
        }

        .zl-x {
            width: 1px;
            height: 40px;
            background: #f5f5f5;
        }

        .z-img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
        }
    }

    .zz-r {
        flex: 1;
        margin-left: 32px;

        .z-t {
            font-size: 1rem;
            margin-bottom: 8px;
            display: flex;
            justify-content: space-between;
            color: #Fff
        }

        .as {
            margin-bottom: 16px;
        }
    }
}

.i-t {
    margin-bottom: 12px;
    color: #fff;
}

.i-i {
    margin-bottom: 16px;
}


.dad {
    height: 100%;
    display: flex;
    align-items: center;
    color: #f0c163;
    cursor: pointer;
    padding-right: 16px;
}

.dsf {
    margin-top: 30px;
    text-align: center;
    font-size: 16px;
}

.butt {
    width: 100%;
    height: 48px;
    background: #f0c163;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
}
</style>